import api from './api';
import { RecruitJobOffer, RecruitJobOfferStatus } from '../types/recruitment';

export async function fetchJobOffers(): Promise<RecruitJobOffer[]> {
	const { data } = await api.get('/recruit/job_offers');
	return Array.isArray(data) ? data : (data?.data ?? []);
}

export async function createJobOffer(payload: Partial<RecruitJobOffer>): Promise<RecruitJobOffer> {
	const { data } = await api.post('/recruit/job_offers', payload);
	return data;
}

export async function updateJobOffer(id: number, payload: Partial<RecruitJobOffer>): Promise<RecruitJobOffer> {
	// Konwersja pól edytora na aliasy *_html akceptowane w backendzie
	const body: any = { ...payload };
	if (body.description_md !== undefined) body.description_html = body.description_md;
	if (body.requirements_md !== undefined) body.requirements_html = body.requirements_md;
	if (body.benefits_md !== undefined) body.benefits_html = body.benefits_md;
	const { data } = await api.put(`/recruit/job_offers/${id}`, body);
	return data;
}

export async function deleteJobOffer(id: number): Promise<{ success: boolean }>{
	// Backend może nie posiadać jeszcze tego endpointu – obsłużymy błąd po stronie UI
	const { data } = await api.delete(`/recruit/job_offers/${id}`);
	return data;
}

export const JOB_OFFER_STATUSES: RecruitJobOfferStatus[] = ['draft','open','paused','closed'];

export async function copyJobOffer(id: number): Promise<{ success: boolean; id: number; slug: string }>{
	const { data } = await api.post(`/recruit/job_offers/${id}/copy`, {});
	return data;
}

export async function fetchStressQuestionCategories(): Promise<string[]> {
	const { data } = await api.get('/recruit/stress_question_categories');
	return data?.data || [];
}


export interface RecruitCandidateRow {
  id: number;
  full_name: string;
  email: string;
  phone: string | null;
  iq_percent?: number | null;
  stress_percent?: number | null;
}

export async function fetchCandidatesForOffer(offerId: number): Promise<RecruitCandidateRow[]> {
  const { data } = await api.get(`/recruit/job_offers/${offerId}/candidates`);
  return data?.data || [];
}


